"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const widget_frame_1 = require("./widget-frame");
const markdown_1 = require("../markdown");
class MarkdownWidget extends React.Component {
    render() {
        const { props } = this;
        return (React.createElement(markdown_1.MarkdownWidgetSrc.Consumer, null, widgetSrc => (React.createElement(markdown_1.MarkdownWidgetState.Consumer, null, widgetState => (React.createElement(widget_frame_1.WidgetFrame, { srcDoc: createDoc({ code: props.code, widgetSrc, widgetState }), src: "/" }))))));
    }
}
exports.MarkdownWidget = MarkdownWidget;
const createDoc = (o) => {
    return [
        `<!doctype html>`,
        `<html>`,
        `<head>`,
        `<script src="${o.widgetSrc}"></script>`,
        `</head>`,
        `<body>`,
        `<div data-widget-mount></div>`,
        `<textarea data-widget-state style="display: none;">`,
        encodeURIComponent(JSON.stringify({
            state: o.widgetState,
            code: o.code
        })),
        `</textarea>`,
        `</body>`,
        `</html>`
    ].join("");
};
//# sourceMappingURL=markdown-widget.js.map